import type { CellContext } from '@tanstack/react-table';
import { formatPercentage } from '@utils';
import type { DataGridColumnDef, DataGridColumnDefOptions } from '../../data-grid.type';

export function getColumnDefPercentage<T>(_col: DataGridColumnDef<T>, options: DataGridColumnDefOptions) {
	return function PercentageCell(context: CellContext<T, unknown>) {
		const value = Number(context.getValue());

		if (isNaN(value)) return null;

		return formatPercentage(value, { locale: options.locale });
	};
}
